import { render, staticRenderFns } from "./ChanpinGuige.vue?vue&type=template&id=9d5b22ce&scoped=true&"
import script from "./ChanpinGuige.vue?vue&type=script&lang=js&"
export * from "./ChanpinGuige.vue?vue&type=script&lang=js&"
import style0 from "./ChanpinGuige.vue?vue&type=style&index=0&id=9d5b22ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5b22ce",
  null
  
)

export default component.exports